export default "__VITE_ASSET__6LaqC9YR__"